import { NgModule } from '@angular/core';

import { UiSwitchComponent } from './ui-switch.component';

@NgModule({
    declarations: [UiSwitchComponent],
    exports: [UiSwitchComponent]
})
export class UiSwitchModule {
}


// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/angular2-ui-switch/src/index.ts